import { SERVER_URL } from '../config';

/**
 * Upload image files to the server.
 * @param {File[]} files
 * @param {string} token - JWT auth token
 * @returns {Promise<string[]>} Array of uploaded image URLs
 */
export async function uploadImages(files, token) {
  if (!files || files.length === 0) return [];

  const formData = new FormData();
  files.forEach(file => formData.append('files', file));

  const response = await fetch(`${SERVER_URL}/upload-images`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Failed to upload images');
  }

  const data = await response.json();
  return data.images.map(img => img.image_url);
}
